// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"81":"async-mathjax","746":"async-graph"}[chunkId] + ".js";
};